import _ from 'lodash';
import angular from 'angular';
import { CANDIDATE_FEEDBACK_STATUSES } from '../constants/feedback';

const RecruiterCandidateService = (CandidateService, CommonCodeService, PositionService, WorkflowService, $timeout) => {
    const getCandidateFeedback = (candidate, workflow = {}, position) => {
        if (workflow.feedback) {
            return workflow.feedback;
        }
        const requestFeedbackEventIndex = _.findIndex(workflow.events, { eventType: WorkflowService.eventTypes.REQUEST_FEEDBACK });
        const backToProspectsEventIndex = _.findIndex(workflow.events, { eventType: WorkflowService.eventTypes.BLOCK_REQUEST_FEEDBACK });

        const isBackToProspectEventExists = backToProspectsEventIndex !== -1;
        const isRequestFeedbackEventExists = requestFeedbackEventIndex !== -1;

        const isCandidateMovedBackToReview = isBackToProspectEventExists
            && isRequestFeedbackEventExists
            && backToProspectsEventIndex < requestFeedbackEventIndex;

        if (isCandidateMovedBackToReview) {
            return {};
        }

        const feedback = _.find(position?.feedbackOnCandidates, { talentId: workflow.talentId });

        const isFeedbackFromEmployerExists = WorkflowService.isFeedbackFromEmployerExists(_.get(feedback, 'status', null));

        if (feedback && isFeedbackFromEmployerExists) {
            $timeout(async () => {
                const feedbackProviders = await PositionService.getFeedbackProviders(position);
                feedback.feedbackProviderName = feedbackProviders[feedback.employerRepId];
            });
        }
        return feedback || { status: CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND };
    };

    const getCandidateWorkflow = (candidate, workflows, position) => {
        const workflow = _.find(workflows, { talentId: candidate.talentID });

        if (!workflow) {
            return {};
        }

        const feedback = getCandidateFeedback(candidate, workflow, position);

        return {
            ...workflow,
            feedback,
        };
    };

    const getProspectCandidates = (candidates, isShowAll, isShowActive) => (candidates || []).filter((candidate) => {
        if (isShowAll) {
            return true;
        }

        const isCandidateWorkflowExist = !candidate.workflow;
        const isCandidateWorkflowStatusHidden = _.get(candidate, 'workflow.recruiterStatus.current', '') === 'Hidden';
        const isAcceptablePredictionScore = candidate.predictionScore >= 95.0 / 100.0;
        const isAlreadyInProcess = isCandidateWorkflowExist && isCandidateWorkflowStatusHidden;

        return !isAlreadyInProcess && isShowActive && isAcceptablePredictionScore;
    });

    const bulkClaimCandidates = async ({
        talentIds,
        positionId,
        recruiterId,
    }) => WorkflowService.bulkClaimOnRecruiterSide({ talentIds, positionId, recruiterId });

    const getPreparedCandidate = (talent, recruiters, allSamples, unselectedSamples) => {
        const residency = CommonCodeService.getLocationString(talent.residency);
        const { workflow } = talent;
        const recruiter = recruiters.find(({ _id }) => _id === workflow.recruiterId);

        return {
            talentId: talent.talentId,
            talentID: talent.talentId,
            workflow,
            fullName: talent.name,
            currentJob: _.find(talent.employmentHistory, { isCurrent: true }),
            previousJob: _.find(talent.employmentHistory, { isCurrent: false }),
            predictionScore: talent.predictionScore,
            residency,
            recruiter,
            candidateData: talent,
            campaignStatus: talent.campaignStatus,
            sample: (allSamples || []).find(({ talentId }) => talentId === talent.talentId),
            unselectedSample: unselectedSamples.find(({ talentId }) => talentId === talent.talentId),
        };
    };

    return {
        bulkClaimCandidates,
        getCandidateFeedback,
        getCandidateWorkflow,
        getProspectCandidates,
        getPreparedCandidate,
    };
};

angular.module('TALENYA-FE')
    .factory('RecruiterCandidateService', RecruiterCandidateService);
